import { Modal } from "@/components/modal-base";
import { ModalContainer, TopLabel } from "./styles";
import { Input } from "@/components/inputs";
import { useState } from "react";
import { Page } from "@/components/page-base";
import theme from "@/styles/theme";
import { EmbaixadorService } from "@/modules/embaixador/services";
import { toast } from "react-toastify";

interface ISelectPixKeyModalProps {
  modal: boolean;
  toggleModal: () => void;
}

export const SelectPixKeyModal: React.FC<ISelectPixKeyModalProps> = ({
  modal,
  toggleModal
}) => {
  const [pixKeytype, setPixKeytype] = useState<string>("");
  const [pixKeyvalue, setPixKeyvalue] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [errorForm, setErrorForm] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  const optionsSelect = [
    { value: "CPF", label: "CPF" },
    { value: "CNPJ", label: "CNPJ" },
    { value: "EMAIL", label: "Email" },
    { value: "PHONE", label: "Telefone" }
  ];

  const validatePixKey = () => {
    switch (pixKeytype) {
      case "CPF":
        if (pixKeyvalue.length !== 11) {
          setErrorMessage("CPF precisa ter 11 dígitos");
          setErrorForm(true);
          return false;
        }
        break;
      case "CNPJ":
        if (pixKeyvalue.length !== 14) {
          setErrorMessage("CNPJ precisa ter 14 dígitos");
          setErrorForm(true);
          return false;
        }
        break;
      case "EMAIL":
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(pixKeyvalue)) {
          setErrorMessage("Email inválido");
          setErrorForm(true);
          return false;
        }
        break;
      case "PHONE":
        if (pixKeyvalue.length !== 11) {
          setErrorMessage("Telefone precisa ter 11 dígitos");
          setErrorForm(true);
          return false;
        }
        break;
      default:
        setErrorMessage("Selecione um tipo de chave válido");
        setErrorForm(true);
        return false;
    }
    setErrorMessage("");
    return true;
  };

  const handleSubmit = async () => {
    setLoading(true);
    setErrorMessage("");
    validatePixKey();
    const res = await EmbaixadorService.sendPixKey({
      pixKeytype,
      key: pixKeyvalue
    });
    if (res.success) {
      toast.success(res.message);
      setPixKeyvalue("");
      toggleModal();
    } else {
      toast.error(res.message);
    }
    setLoading(false);
  };

  return (
    <Modal.Root open={modal} onClose={toggleModal} maxWidth="900px">
      <Modal.Header justifyContent="end">
        <Modal.HeaderText text={"Indique e Ganhe"} />
        <Modal.Icon
          icon="Close"
          cursor="pointer"
          onClick={toggleModal}
          iconColor="black"
        />
      </Modal.Header>
      <Modal.Content>
        <TopLabel>Cadastre sua chave para realizar os seus saques</TopLabel>
        <ModalContainer>
          <span className="lbl">Selecione e digite a sua chave</span>
          <Input.Select
            onChange={(newValue) => {
              setPixKeyvalue("")
              setPixKeytype(newValue.toString());
            }}
            selectedValue={pixKeytype}
            options={optionsSelect}
            fontColor="black"
          />
          <Input.Label
            placeholder={pixKeytype}
            errorMessage={errorMessage}
            error={errorForm}
            value={pixKeyvalue}
            setValue={setPixKeyvalue}
            maxLength={
              pixKeytype === "CPF" ? 11 : pixKeytype === "CNPJ" ? 14 : undefined
            }
          />
          <div style={{ marginTop: "3vh" }}>
            <Page.Button
              label={loading ? "Cadastrando..." : "Cadastrar"}
              bgColor={theme.colors.palete.green}
              hoverBgcolor={theme.colors.palete.greenHover}
              disabled={!pixKeytype || !pixKeyvalue || loading}
              onClick={handleSubmit}
            />
          </div>
        </ModalContainer>
      </Modal.Content>
    </Modal.Root>
  );
};
